import React, {
  DetailedHTMLProps,
  forwardRef,
  useMemo,
} from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import noop from 'lodash/noop';
import {
  pluralize,
} from '@populateui/utils';
import Button from 'pages/Dashboard/components/Button';
import Spinner from 'pages/Dashboard/components/Spinner';

const Dropdown = forwardRef(({
  children,
  className,
  objectName = 'Result',
  count,
  pageProperties,
  isLoading,
  fetchNextPage = noop,
  showTotalSize = false,
  ...props
}: DetailedHTMLProps<any, any>, ref) => {
  const optionsLoading = useMemo(
    () => count > 0 && isLoading,
    [count, isLoading],
  );

  return (
    <div
      {...props}
      className="h-full relative -m-2"
      ref={ref}
    >
      <div className={clsx(className, '!px-2')}>
        {children}
        {pageProperties?.hasNextPage && (
          <Button
            className="!hover:bg-transparent !font-medium !text-gray-400 !w-full !text-center !p-2 !max-w-none !flex items-center !flex-row"
            variant="text"
            onClick={fetchNextPage}
            disabled={optionsLoading}
          >
            {optionsLoading && <Spinner className="!mr-2" />}
            <div>{optionsLoading ? 'Loading...' : 'Load More'}</div>
          </Button>
        )}
      </div>
      {!isNil(pageProperties) && showTotalSize && (
        <div className="p-2 text-xs sticky bottom-0">
          {pluralize(objectName, pageProperties?.totalSize)}
          {' '}
          Found
        </div>
      )}
    </div>
  );
});

export default Dropdown;
